export const BUTTON_CONFIRM_TEXTS = {
  ACCEPT: 'Aceptar',
  CANCEL: 'Cancelar',
  EXIT: 'Salir'
}

export const EXPIRATION_STATUS = {
  EXPIRING_SOON: 'ES',
  EXPIRED: 'EX',
  OK: 'OK'
}

export const EXPIRATION_INDICATOR = {
  EXPIRING_SOON: '#FFF1BF',
  EXPIRED: '#FFC7BF',
  OK: 'none'
}
